export default __webpack_public_path__ + "static/media/7.a8a3e20f.webp";